import { render, staticRenderFns } from "./Unsupportedbrowser.vue?vue&type=template&id=da5a4c88&"
import script from "./Unsupportedbrowser.vue?vue&type=script&lang=js&"
export * from "./Unsupportedbrowser.vue?vue&type=script&lang=js&"
import style0 from "./Unsupportedbrowser.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports